var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-exclamation-triangle","titulo":"ENTREGAS SEM COMPROMETIMENTO","qtd":_vm.qtd,"loading":_vm.loading,"color":"#ffa600"}})
}
var staticRenderFns = []

export { render, staticRenderFns }